import { Margin } from "./Styles/Margin";
import { Padding } from "./Styles/Padding";
import { Text } from "./Styles/Text";

export const StylesEditor = () => (
  <div>
    <Text />
    <Margin />
    <Padding />
  </div>
);
